<ng-container *ngIf="!router.url.includes('cart') && !router.url.includes('password')">



    <app-search *ngIf="showSearch" (searchToggleEvent)="searchToggle($event)"></app-search>

    <ng-container *ngIf="notification != ''">
        <div class="container-fluid special-header-row d-none d-sm-none d-md-none d-lg-flex d-xl-flex align-items-center justify-content-center"
            *ngIf="!hideSpecial">
            <div class="row">
                <div class="col text-center" [innerHTML]="notification">
                </div>
            </div>

            <div class="special-header-close">
                <!--<img loading="lazy" src="assets/img/icn-close.svg" (click)="hideSpecial = true" />-->
                <i class="text-white material-symbols-outlined" (click)="hideSpecial = true">cancel</i>
            </div>
        </div>
    </ng-container>
    <div class="hover-fix">
        <div class="container top-header-row py-3 d-none d-sm-none d-md-block "
            (mouseleave)="closeAccountMenu(); removeClass('courses-show'); removeClass('study-methods-show');"
            (mouseover)="closeAccountMenu(); removeClass('courses-show'); removeClass('study-methods-show');">
            <div class="row">
                <div class="col text-right">
                    <ul class="d-flex justify-content-end align-items-center">
                        <ng-container *ngFor="let header of topHeaders; let i = index;">
                            <li *ngIf="header?.items?.length <= 0">
                                <a [routerLink]="header.url">{{header.title}}</a>
                            </li>
                        </ng-container>

                        <!--<li (click)="showSearch = !showSearch"> <i class="fa fa-search hand"></i></li>-->
                        <li (click)="showSearch = !showSearch"> <i class="material-symbols-outlined">search</i></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>


    <header class="header py-4">
        <div class="container" style="position: relative;">
            <div class="row d-flex align-items-center">

                <div routerLink="/mobile-menu" *ngIf="!router.url.includes('mobile-menu')"
                    class="col-3 d-flex d-sm-flex d-md-none d-lg-none d-xl-none justify-content-start">
                    <img loading="lazy" src="assets/img/icons/icn-open-down.svg" />
                </div>

                <div routerLink="/home" *ngIf="router.url.includes('mobile-menu')"
                    class="col-3 d-flex d-sm-flex d-md-none d-lg-none d-xl-none justify-content-start">
                    <img loading="lazy" src="assets/img/icons/icn-close-simple.svg" />
                </div>


                <div class="col-6 col-sm-6 col-md-2 col-lg-3 d-flex justify-content-start hidden-mobile"
                    (mouseover)="closeAccountMenu(); removeClass('courses-show'); removeClass('study-methods-show');">
                    <a routerLink="/"><img loading="lazy" src="assets/img/img-logo.svg" width="130"/></a>
                </div>

                <div class="col-6 col-sm-6 col-md-2 d-flex justify-content-center show-mobile mob-logo-center"
                    (mouseover)="closeAccountMenu(); removeClass('courses-show'); removeClass('study-methods-show');">
                    <a routerLink="/"><img loading="lazy" class="mob-logo" src="assets/img/icons/mob-icon.svg" /></a>
                </div>


                <div class="col-6 col-md-7 col-lg-6 d-none d-sm-none d-md-flex d-lg-flex d-xl-flex justify-content-center"
                    style="position: relative;">
                    <ul>
                        <li
                            (mouseover)="removeClass('study-methods-show'); appendClass('courses-show'); resetUpcoming();">
                            <a routerLink="/courses">COURSES</a>
                        </li>
                        <li *ngIf="loadingHeader">
                            <mat-spinner diameter="16">
                            </mat-spinner>
                        </li>

                        <ng-container *ngFor="let header of headers;  let i=index">
                            <li style="text-transform: uppercase;"
                                (mouseover)="appendClass(header.url); removeOtherSubheadClasses(header.url); removeClass('courses-show'); closeAccountMenu();">
                                <a [routerLink]="header.url">{{header.title}}</a>
                            </li>
                        </ng-container>

                    </ul>

                    <ng-container *ngFor="let header of headers;  let i=index">
                        <div *ngIf="header?.subitems && showMenuDropDown == header.url"
                            class="w-100 bg-white rounded shadow study-methods-menu-container"
                            (mouseleave)="removeClass(header.url); removeClass('courses-show'); closeAccountMenu()">
                            <div class="px-6">
                                <ng-container *ngFor="let subhead of header?.subitems">
                                    <div class="d-block py-5 study-method-menu-item cursor-pointer">
                                        <a routerLink="{{ subhead?.url }}">
                                            <div class="d-flex align-items-start">
                                                <div *ngIf="subhead?.image" class="mr-6">
                                                    <img loading="lazy" style="width: 40px;" [src]="subhead?.image" />
                                                </div>
                                                <div>
                                                    <h4 class="font-size-16">{{ subhead?.title }}</h4>
                                                    <p class="mb-0 font-size-14">{{ subhead?.text }}</p>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </ng-container>

                </div>

                <div class="col-3 d-flex justify-content-end"
                    (mouseover)=" removeClass('courses-show'); removeClass('study-methods-show');">
                    <ul class="header-menu-right d-flex align-items-center">
                        <li class="d-none d-sm-none _d-md-inline-block d-md-flex align-items-center cursor-pointer" *ngIf="loggedIn" mat-button
                            [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger"
                            (mouseenter)="menuTrigger.openMenu()">
                            <!--<img loading="lazy" src="assets/img/icons/icn-profile.svg" style="position: relative; top: -2px;" />-->
                            <i class="material-symbols-outlined mr-1">account_circle</i>

                            Hi {{ firstName }} <span style="font-size: 18px;">▾</span>
                            <mat-menu #menu="matMenu" xPosition="before" class="flag-menu">
                                <span (mouseleave)="closeAccountMenu()">
                                    <div mat-menu-item routerLink="/my-account" class="pl-7 pr-20 ">My Account
                                        <img loading="lazy" class="acc-ico" src="assets/img/icn-nav-arrow-right.svg" />
                                    </div>
                                    <div mat-menu-item (click)="logout()" class="pl-7 pr-20 ">Logout
                                        <img loading="lazy" class="acc-ico" src="assets/img/icn-nav-arrow-right.svg" />
                                    </div>
                                </span>
                            </mat-menu>
                        </li>
                        <li class="d-none d-sm-none d-md-inline-block cursor-pointer" *ngIf="!loggedIn"><a
                                routerLink="/cart/login">LOGIN</a></li>
                        <li class="d-none d-sm-none d-md-inline-block" *ngIf="!loggedIn">|</li>
                        <li class="d-none d-sm-none d-md-inline-block cursor-pointer" *ngIf="!loggedIn"><a
                                routerLink="/cart/register">REGISTER</a></li>

                        <li class="cart" *ngIf="cart_counter == 0">
                            <div>
                                <!--<img loading="lazy" src="assets/img/icn-cart-disabled.svg" />-->
                                <i class="material-symbols-outlined">shopping_cart</i>
                                <div class="cart-counter" [class.d-none]="cart_counter <= 0">{{ cart_counter }}</div>
                            </div>
                        </li>


                        <li class="cart cursor-pointer" *ngIf="cart_counter != 0" routerLink="/cart">
                            <div>
                                <!--<img loading="lazy" src="assets/img/icn-cart.svg" />-->
                                <i class="material-symbols-outlined">shopping_cart</i>
                                <div class="cart-counter" [class.d-none]="cart_counter <= 0">{{ cart_counter }}</div>
                            </div>
                            <!-- <mat-menu #cartmenu="matMenu" xPosition="before">
                                <ng-container  *ngIf="myCart.length > 0">
                                    <button *ngFor="let item of myCart" mat-menu-item class="pl-7 pr-20 btn-hover-text-primary">{{ item.SubjectName._text }}</button>
                                    <button (click)="clearCart()" mat-menu-item class="pl-7 pr-20 font-weight-bolder text-primary">Clear Cart</button>
                                    <button routerLink="/cart/billing" mat-menu-item class="pl-7 pr-20 font-weight-bolder text-primary">Checkout <mat-icon color="primary" style="position: relative; top: 1px;">arrow_forward</mat-icon></button>
                                </ng-container>

                                <ng-container *ngIf="myCart.length <= 0">
                                    <button mat-menu-item class="pl-7 pr-20">No items in cart yet.</button>
                                </ng-container>
                            </mat-menu> -->
                        </li>
                    </ul>
                </div>
            </div>

            <div class="w-100 courses-menu-container"
                (mouseleave)="closeAccountMenu(); removeClass('courses-show'); removeClass('study-methods-show');">
                <div class="container-fluid">
                    <div class="row shadow">
                        <div class="col-3 py-8 px-7 mega-menu-col-1">
                            <h4>Courses</h4>

                            <ngx-skeleton-loader *ngIf="!megaMenuLoaded" count="4" animation="pulse" [theme]="{ 
                                'height': '25px',
                                'width': '100%'
                            }"></ngx-skeleton-loader>

                            <ul *ngIf="megaMenuLoaded">
                                <li *ngFor="let item of megaMenu"
                                    [class.active]="selectedMegaMenuCourse?.identifier == item?.identifier"
                                    (mouseover)="selectCourse(item)">
                                    <a routerLink="/courses/{{ item?.slug }}">{{ item?.short_title
                                        }}</a>
                                </li>
                            </ul>
                        </div>
                        <div class="col-3 py-8 px-7 mega-menu-col-2">
                            <h4>Levels</h4>

                            <ngx-skeleton-loader *ngIf="!megaMenuLoaded" count="4" animation="pulse" [theme]="{ 
                                'height': '25px',
                                'width': '100%'
                            }"></ngx-skeleton-loader>

                            <ul *ngIf="megaMenuLoaded">
                                <li (mouseover)="selectLevel(level)"
                                    [class.active]="selectedMegaMenuLevel?.SubjectLevelKey?._text == level?.SubjectLevelKey?._text"
                                    *ngFor="let level of selectedMegaMenuCourse.SubjectLevel">
                                    <a
                                        [routerLink]="['/courses', selectedMegaMenuCourse?.slug, slugify(selectedMegaMenuLevel?.SubjectLevelName?._text)]">
                                        {{ level?.SubjectLevelName?._text }}
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div class="col-3 py-8 px-7 mega-menu-col-3">
                            <h4>Subjects</h4>

                            <ngx-skeleton-loader *ngIf="!megaMenuLoaded" count="4" animation="pulse" [theme]="{ 
                                'height': '25px',
                                'width': '100%'
                            }"></ngx-skeleton-loader>

                            <ng-container>
                                <ul *ngIf="megaMenuLoaded && selectedMegaMenuLevel !== undefined">
                                    <li *ngFor="let subject of selectedMegaMenuLevel.Subjects?.Subject">
                                        <a (mouseover)="selectSubject(subject)"
                                            (click)="filterSubject(slugify(selectedMegaMenuLevel?.SubjectLevelName?._text), subject?.slug)"
                                            [routerLink]="['/courses', selectedMegaMenuCourse?.slug, slugify(selectedMegaMenuLevel?.SubjectLevelName?._text)]"
                                            [queryParams]="{ subject: subject?.slug }">
                                            {{ subject?.title || subject?.SubjectName?._text }}
                                        </a>
                                    </li>
                                </ul>
                            </ng-container>


                        </div>
                        <div class="col-3 py-8 px-7 mega-menu-col-4">
                            <h4>Upcoming Courses</h4>


                            <div *ngIf="upcomingCourseState == 'loading'"
                                class="d-flex justify-content-center align-items-center preloader">
                                <mat-spinner diameter="24"></mat-spinner>
                            </div>

                            <div class="card shadow-xs card-subject mb-4" *ngIf="upcomingCourseState == 'show'"
                                [style.border-top-color]="selectedMegaMenuCourse?.bg_color">
                                <div class="card-body" style="padding: 17px;">
                                    <div class="container-fluid">
                                        <div class="row">
                                            <div class="col-auto pl-0 pr-0">
                                                <h3 class="font-weight-bolder"
                                                    [style.color]="selectedMegaMenuCourse?.bg_color">
                                                    {{selectedMegaMenuSubject?.SubjectCode?._text}}</h3>
                                            </div>
                                            <div class="col pl-2 pr-0 text-right">
                                                <h6 class="font-weight-normal product-study-method"
                                                    style="color: #818181; font-family: 'Lato', arial, sans-serif; font-size: 20px;">
                                                    {{upcomingCourse?.StudyMethodName?._text}}</h6>
                                            </div>
                                        </div>
                                        <div class="row card-content-separator">
                                            <div class="col p-0">
                                                <p class="card-body-header text-uppercase mt-3"
                                                    style="font-size: 14px; height: 40px;">
                                                    <strong>{{selectedMegaMenuSubject?.title}}</strong>
                                                </p>
                                                <p class="card-body-description">
                                                    <ng-container
                                                        *ngFor="let how_it_works of selectedMegaMenuSubject?.how_it_works_sections">
                                                        <ng-container
                                                            *ngIf="how_it_works?.study_method_identifier == upcomingCourse?.StudyMethodKey?._text">
                                                            <span
                                                                *ngIf="how_it_works?.card_generic_copy?.content">{{parseIt(how_it_works?.card_generic_copy?.content)}}</span>
                                                            <span
                                                                *ngIf="!how_it_works?.card_generic_copy?.content">{{parseIt(how_it_works?.card_content)}}</span>
                                                        </ng-container>
                                                    </ng-container>

                                                </p>
                                            </div>
                                        </div>
                                        <div class="row" style="height: 32px;">
                                            <ng-container *ngIf="regions">
                                                <ng-container *ngFor="let region of regions">
                                                    <div class="d-inline-flex region-pill mb-2"
                                                        *ngIf="region?.RegionName?._text">{{region?.RegionName?._text }}
                                                    </div>
                                                </ng-container>
                                            </ng-container>
                                        </div>
                                        <div class="row mt-3 card-content-separator">
                                            <div class="col p-0">
                                                <ng-container *ngIf="upcomingSubject">
                                                    <p class="mt-5 mb-0 fg-light-blue"
                                                        *ngIf="upcomingSubject.DaysLeftToEnroll?._text && upcomingSubject?.DaysLeftToEnroll?._text < 30">
                                                        <img loading="lazy" src="assets/img/icn-timer-blue.svg"
                                                            style="vertical-align: middle; position: relative; top: -2px;">
                                                        <strong>{{upcomingSubject.DaysLeftToEnroll?._text}}
                                                            Days</strong> left to enroll
                                                    </p>
                                                    <p *ngIf="!upcomingSubject.DaysLeftToEnroll?._text && upcomingSubject?.DaysLeftToEnroll?._text >= 30"
                                                        class="mt-5 mb-0 fg-light-blue">
                                                        &nbsp;</p>

                                                    <p class="font-size-18 mb-4"><strong>R{{
                                                            upcomingSubject.UnitPrice?._text
                                                            }}</strong></p>
                                                </ng-container>
                                            </div>
                                            <div class="col-12 p-0"
                                                *ngIf="selectedMegaMenuCourse?.slug && selectedMegaMenuSubject?.SubjectLevelKey?._text && selectedMegaMenuSubject?.slug">

                                                <a *ngIf="upcomingCourse?.StudyMethodName?._text; else noUpcomingBlock"
                                                    [routerLink]="['/courses', selectedMegaMenuCourse?.slug,
                                                        selectedMegaMenuSubject?.SubjectLevelKey?._text,
                                                        selectedMegaMenuSubject?.slug,
                                                        slugify(upcomingCourse?.StudyMethodName?._text)]">
                                                    <button type="button"
                                                        class="mt-3 btn btn-primary btn-md btn-block rounded-pill font-bold shadow-xs"
                                                        style="font-size: 14px;">
                                                        More Details
                                                    </button>
                                                </a>
                                                <ng-template #noUpcomingBlock>
                                                    <a
                                                        [routerLink]="['/courses', selectedMegaMenuCourse?.slug,
                                                            selectedMegaMenuSubject?.SubjectLevelKey?._text,
                                                            selectedMegaMenuSubject?.slug]">
                                                        <button type="button"
                                                            class="mt-3 btn btn-primary btn-md btn-block rounded-pill font-bold shadow-xs"
                                                            style="font-size: 14px;">
                                                            More Details
                                                        </button>
                                                    </a>
                                                </ng-template>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </header>
</ng-container>

<ng-container *ngIf="router.url.includes('password')">
    <header class="header py-4">
        <div class="container">
            <div class="row d-flex align-items-center">
                <div class="col-10 d-flex justify-content-start hidden-mobile">
                    <a routerLink="/"><img loading="lazy" src="assets/img/img-logo.svg" width="130"/></a>
                </div>

                <div class="col-10 d-flex  justify-content-start show-mobile ">
                    <a routerLink="/"><img loading="lazy" class="mob-logo" src="assets/img/icons/mob-icon.svg" /></a>
                </div>

                <div class="col-2 d-flex justify-content-end " (click)="goBack()">
                    <img loading="lazy" class="cursor-pointer" src="assets/img/icons/icn-close.svg" />
                </div>
            </div>
        </div>
    </header>
</ng-container>

<ng-container *ngIf="router.url.includes('cart')">
    <header class="header py-4">
        <div class="container hidden-mobile">
            <div class="row d-flex align-items-center">
                <div class="col-3 d-flex justify-content-start">
                    <a routerLink="/"><img loading="lazy" src="assets/img/img-logo.svg" width="130"/></a>
                </div>
                <div class="col-6 d-flex journey-to-the-center-of-the-earth ">
                    <ng-container
                        *ngIf="router.url.includes('cart/') && !router.url.includes('cart/login') && !router.url.includes('cart/thanks') && !router.url.includes('cart/thanks-eft') && !router.url.includes('cart/thanks-cc') && !router.url.includes('cart/register')">
                        <span [class.active]="router.url.includes('delivery')">Delivery</span>
                        <img loading="lazy" class="journey-icn" src="assets/img/icn-nav-arrow-right.svg" />
                        <span [class.active]="router.url.includes('billing')">Billing</span>
                        <img loading="lazy" class="journey-icn" src="assets/img/icn-nav-arrow-right.svg" />
                        <span [class.active]="router.url.includes('payment')">Payment</span>
                    </ng-container>
                </div>
                <ng-container *ngIf="router.url.includes('cart') && !router.url.includes('cart/')">
                    <div class="col-3 d-flex justify-content-end " (click)="cartGoBack()">
                        <img loading="lazy" class="cursor-pointer" src="assets/img/icons/icn-close.svg" />
                    </div>
                </ng-container>
                <ng-container
                    *ngIf="router.url.includes('cart/') && !router.url.includes('cart/login') && !router.url.includes('cart/thanks') && !router.url.includes('cart/thanks-eft') && !router.url.includes('cart/thanks-cc') && !router.url.includes('cart/register')">
                    <div class="col-3 d-flex justify-content-end " routerLink="/courses/acca/all">
                        <img loading="lazy" class="cursor-pointer" src="assets/img/icons/icn-close.svg" />
                    </div>
                </ng-container>

            </div>
        </div>

        <div class="container show-mobile">
            <div class="row d-flex align-items-center">
                <div class="col-3 d-flex justify-content-start" (click)="goBack()">
                    <img loading="lazy" src="assets/img/icons/icn-nav-arrow-left.svg" /> <span class="b-text">Back</span>
                </div>
                <div class="col-6 col-sm-6 col-md-3 d-flex justify-content-center show-mobile mob-logo-center">
                    <a routerLink="/"><img loading="lazy" class="mob-logo" src="assets/img/icons/mob-icon.svg" /></a>
                </div>

                <div class="col-3 d-flex justify-content-end " routerLink="/">
                    <img loading="lazy" class="cursor-pointer" src="assets/img/icons/icn-close.svg" />
                </div>
            </div>
        </div>
    </header>
    <ng-container
        *ngIf="router.url.includes('cart/') && !router.url.includes('cart/login') && !router.url.includes('cart/thanks') && !router.url.includes('cart/thanks-eft') && !router.url.includes('cart/thanks-cc') && !router.url.includes('cart/register')">
        <div class="white-bg show-mobile journey-mobile">
            <div class="container">
                <div class="col-12 d-flex journey-to-the-center-of-the-earth ">

                    <span [class.active]="router.url.includes('delivery')">Delivery</span>
                    <img loading="lazy" class="journey-icn" src="assets/img/icn-nav-arrow-right.svg" />
                    <span [class.active]="router.url.includes('billing')">Billing</span>
                    <img loading="lazy" class="journey-icn" src="assets/img/icn-nav-arrow-right.svg" />
                    <span [class.active]="router.url.includes('payment')">Payment</span>

                </div>
            </div>
        </div>
    </ng-container>

</ng-container>